import { MdInfoOutline } from 'react-icons/md';

interface InfoTooltipProps {
  text: string;
  className?: string;
}

export const InfoTooltip = ({ text, className = '' }: InfoTooltipProps) => (
  <span className={`group relative inline-flex ${className}`}>
    <button
      type="button"
      className="flex h-4 w-4 items-center justify-center rounded-full text-gray-400 transition-colors hover:text-gray-600 focus:text-gray-600 focus:outline-none"
      aria-label="Más información"
    >
      <MdInfoOutline className="text-sm" />
    </button>
    <span
      role="tooltip"
      className="pointer-events-none absolute bottom-full left-0 z-30 mb-2 w-60 rounded-md bg-gray-900 px-3 py-2 text-xs font-normal normal-case leading-snug text-white opacity-0 shadow-lg transition-opacity duration-150 group-hover:opacity-100 group-focus-within:opacity-100"
    >
      {text}
    </span>
  </span>
);
